import { createAsyncThunk } from '@reduxjs/toolkit';
import { UsersAPI } from '@/api';
import { formatApiError } from '@/utils';
import { IApiError } from '@/models/apiError.model';
import { USERS_LIST_SLICE_NAME } from './models';
import { IGetUsersListDTO, IUser, IUsersListResponse, IUpdateUserDTO } from '@/models/users.model';

export const getUsersList = createAsyncThunk<IUsersListResponse, IGetUsersListDTO, { serializedErrorType: IApiError }>(
  `${USERS_LIST_SLICE_NAME}/getUsersList`,
  async (data) => {
    const response = await UsersAPI.getUsersList(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const getUserDetails = createAsyncThunk<IUser, string, { serializedErrorType: IApiError }>(
  `${USERS_LIST_SLICE_NAME}/getUserDetails`,
  async (id) => {
    const response = await UsersAPI.getUserDetails(id);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const deleteUser = createAsyncThunk<IUser, string, { serializedErrorType: IApiError }>(
  `${USERS_LIST_SLICE_NAME}/deleteUser`,
  async (id) => {
    const response = await UsersAPI.deleteUser(id);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const updateUserDetails = createAsyncThunk<IUser, IUpdateUserDTO, { serializedErrorType: IApiError }>(
  `${USERS_LIST_SLICE_NAME}/updateUserDetails`,
  async (data) => {
    const response = await UsersAPI.updateUserDetails(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const activateUser = createAsyncThunk<IUser, string, { serializedErrorType: IApiError }>(
  `${USERS_LIST_SLICE_NAME}/activateUser`,
  async (id) => {
    const response = await UsersAPI.activateUser(id);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const deactivateUser = createAsyncThunk<IUser, string, { serializedErrorType: IApiError }>(
  `${USERS_LIST_SLICE_NAME}/deactivateUser`,
  async (id) => {
    const response = await UsersAPI.deactivateUser(id);
    return response.data;
  },
  { serializeError: formatApiError },
);
